import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private auth: AuthenticationService, private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.auth.authenticationState.pipe(
      map(isAuth => {
        console.log('✅ AuthGuard revisa:', isAuth);
        if (isAuth) {
          return true;
        } else {
          console.warn('🔒 No autenticado. Redirigiendo...');
          return this.router.createUrlTree(['/']);
        }
      })
    );
  }
}
